import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/recharge"

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}

export function addRecharge(data) {
  return request({
    url: prefix + '/addRecharge',
    method: 'post',
    data: data,
  })
}

export function audit(data) {
  return request({
    url: prefix + '/audit',
    method: 'post',
    data: data,
  })
}

// 删除
export function deleterow(id) {
  return request({
    url: prefix + '/delete/' + id,
    method: 'get'
  })
}
